import { createAction, props } from '@ngrx/store';
import { User } from '../../models';

export const set = createAction('[Auth] Set User', props<{ user: User | null }>());
